import { RegisterTypes } from './actionTypes';

const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
};

const register = (state = initialState, action: any) => {
  switch (action.type) {
    case RegisterTypes.REGISTER_USER:
      console.log("Entro funcion reducer")
      state = {
        ...state,
        loading: true,
        registrationError: null,
      };
      break;
    case RegisterTypes.REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload?.createUser,
        message: action.payload?.createUser,
        registrationError: null,
      };
      break;
    case RegisterTypes.REGISTER_USER_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload?.createUser,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default register;
